import React from 'react';
import { BrowserView, MobileView } from 'react-device-detect';
import { NavLink, useNavigate } from 'react-router-dom';

import Icone from 'Component/Icone';
import Imagem from 'Component/Imagem';
import { useAppSelector } from 'Store';

const MenuLateral = (): React.ReactElement => {
  const navegacao = useNavigate();
  const usuario = useAppSelector((estado) => estado.autenticacao.usuario);

  return (
    <React.Fragment>
      <BrowserView className="position-relative">
        <div
          className="h-100 d-flex flex-column flex-shrink-0 p-3 text-body bg-white shadow-lg overflow-y"
          style={{ width: '280px' }}
        >
          <a href="/" className="d-block mt-3">
            <Imagem
              src="logo-invertida.png"
              height="40"
              className="d-block mx-auto"
            />
          </a>
          <ul className="nav nav-pills flex-column mb-auto mt-5">
            {usuario && ['conteudista'].includes(usuario.permissao) && (
              <li className="nav-item">
                <NavLink
                  to="/admin/inicio"
                  className={({ isActive }) =>
                    `nav-link ${isActive && 'text-white active'}`
                  }
                >
                  <Icone nome="house-fill" className="me-2" />
                  Início
                </NavLink>
              </li>
            )}
            {usuario && ['super', 'admin'].includes(usuario.permissao) && (
              <li className="nav-item">
                <NavLink
                  to="/admin/dashboard"
                  className={({ isActive }) =>
                    `nav-link ${isActive && 'text-white active'}`
                  }
                >
                  <Icone nome="speedometer" className="me-2" />
                  Dashboard
                </NavLink>
              </li>
            )}
            {usuario && ['super', 'admin'].includes(usuario.permissao) && (
              <li className="nav-item">
                <NavLink
                  to="/admin/usuarios"
                  className={({ isActive }) =>
                    `nav-link ${isActive && 'text-white active'}`
                  }
                >
                  <Icone nome="person-badge-fill" className="me-2" />
                  Usuários
                </NavLink>
              </li>
            )}
            {usuario && ['super', 'admin'].includes(usuario.permissao) && (
              <li className="nav-item">
                <NavLink
                  to="/admin/categorias"
                  className={({ isActive }) =>
                    `nav-link ${isActive && 'text-white active'}`
                  }
                >
                  <Icone nome="view-list" className="me-2" />
                  Categorias
                </NavLink>
              </li>
            )}
            {usuario && ['super', 'admin'].includes(usuario.permissao) && (
              <li className="nav-item">
                <NavLink
                  to="/admin/cursos"
                  className={({ isActive }) =>
                    `nav-link ${isActive && 'text-white active'}`
                  }
                >
                  <Icone nome="book-half" className="me-2" />
                  Cursos
                </NavLink>
              </li>
            )}
            {usuario && ['super', 'admin'].includes(usuario.permissao) && (
              <li className="nav-item">
                <NavLink
                  to="/admin/unidades-de-aprendizagem"
                  className={({ isActive }) =>
                    `nav-link ${isActive && 'text-white active'}`
                  }
                >
                  <Icone nome="person-video2" className="me-2" />
                  Uni. de Aprendizagem
                </NavLink>
              </li>
            )}
            {usuario && ['super', 'admin'].includes(usuario.permissao) && (
              <li className="nav-item">
                <NavLink
                  to="/admin/certificados"
                  className={({ isActive }) =>
                    `nav-link ${isActive && 'text-white active'}`
                  }
                >
                  <Icone nome="file-medical-fill" className="me-2" />
                  Certificados
                </NavLink>
              </li>
            )}
            {usuario && ['super', 'admin'].includes(usuario.permissao) && (
              <li className="nav-item">
                <NavLink
                  to="/admin/planos"
                  className={({ isActive }) =>
                    `nav-link ${isActive && 'text-white active'}`
                  }
                >
                  <Icone nome="credit-card-fill" className="me-2" />
                  Planos
                </NavLink>
              </li>
            )}
            {usuario && ['super', 'admin'].includes(usuario.permissao) && (
              <li className="nav-item">
                <NavLink
                  to="/admin/solicitacoes"
                  className={({ isActive }) =>
                    `nav-link ${isActive && 'text-white active'}`
                  }
                >
                  <Icone nome="headset" className="me-2" />
                  Solicitações
                </NavLink>
              </li>
            )}
            {usuario &&
              ['super', 'admin', 'conteudista'].includes(usuario.permissao) && (
                <li className="nav-item">
                  <NavLink
                    to="/admin/tarefas"
                    className={({ isActive }) =>
                      `nav-link ${isActive && 'text-white active'}`
                    }
                  >
                    <Icone nome="database-fill-check" className="me-2" />
                    Tarefas
                  </NavLink>
                </li>
              )}
          </ul>
          <hr />
          <div className="dropdown dropend text-truncate">
            <a
              href="#"
              className="d-flex align-items-center text-body text-decoration-none"
              data-bs-toggle="dropdown"
            >
              <Imagem
                src={usuario?.imagem}
                width="40"
                height="40"
                className="rounded-circle object-fit-cover me-2"
              />
              <strong>
                {usuario?.nome}
                <small className="d-block fw-light text-truncate">
                  {usuario?.email}
                </small>
              </strong>
            </a>
            <ul className="dropdown-menu text-small border-0 shadow">
              <li>
                <button
                  type="button"
                  className="dropdown-item"
                  onClick={() => navegacao('/alterar-senha')}
                >
                  Alterar senha
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className="dropdown-item"
                  onClick={() => navegacao('/login?reset=true')}
                >
                  Sair
                </button>
              </li>
            </ul>
          </div>
        </div>
      </BrowserView>
      <MobileView>
        <nav
          id="admin-navbar-footer"
          className="navbar navbar-expand fixed-bottom navbar-light border-top bg-white p-0 z-index-500"
        >
          <ul className="navbar-nav w-100 d-flex justify-content-between">
            {usuario && ['conteudista'].includes(usuario.permissao) && (
              <li className="nav-item" style={{ flex: 1 }}>
                <NavLink
                  to="/admin/inicio"
                  className={({ isActive }) =>
                    `nav-link text-center ${isActive && 'text-primary'}`
                  }
                >
                  <Icone nome="house-fill" className="mb-1 fs-5" />
                  <small className="d-block">Início</small>
                </NavLink>
              </li>
            )}
            {usuario && ['super', 'admin'].includes(usuario.permissao) && (
              <li className="nav-item" style={{ flex: 1 }}>
                <NavLink
                  to="/admin/dashboard"
                  className={({ isActive }) =>
                    `nav-link text-center ${isActive && 'text-primary'}`
                  }
                >
                  <Icone nome="speedometer" className="mb-1 fs-5" />
                  <small className="d-block">Dashboard</small>
                </NavLink>
              </li>
            )}
            {usuario && ['super', 'admin'].includes(usuario.permissao) && (
              <li className="nav-item" style={{ flex: 1 }}>
                <NavLink
                  to="/admin/usuarios"
                  className={({ isActive }) =>
                    `nav-link text-center ${isActive && 'text-primary'}`
                  }
                >
                  <Icone nome="person-badge-fill" className="mb-1 fs-5" />
                  <small className="d-block">Usuários</small>
                </NavLink>
              </li>
            )}
            {usuario && ['super', 'admin'].includes(usuario.permissao) && (
              <li className="nav-item" style={{ flex: 1 }}>
                <NavLink
                  to="/admin/cursos"
                  className={({ isActive }) =>
                    `nav-link text-center ${isActive && 'text-primary'}`
                  }
                >
                  <Icone nome="book-half" className="mb-1 fs-5" />
                  <small className="d-block">Cursos</small>
                </NavLink>
              </li>
            )}
            {usuario &&
              ['super', 'admin', 'conteudista'].includes(usuario.permissao) && (
                <li className="nav-item" style={{ flex: 1 }}>
                  <NavLink
                    to="/admin/tarefas"
                    className={({ isActive }) =>
                      `nav-link text-center ${isActive && 'text-primary'}`
                    }
                  >
                    <Icone nome="database-fill-check" className="mb-1 fs-5" />
                    <small className="d-block">Tarefas</small>
                  </NavLink>
                </li>
              )}
          </ul>
        </nav>
      </MobileView>
    </React.Fragment>
  );
};

export default MenuLateral;
